// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.glyph-bCgWZh{width:72px;height:72px;color:var(--abr-brand-primary,#1d2088);background:var(--abr-brand-light-solid,#e8e8f4);border:1px solid var(--abr-border,#e0e0ed);border-radius:var(--abr-radius-lg,8px);justify-content:center;align-items:center;display:flex}.muted-xe1h4q{color:var(--abr-text-secondary,#6c6d7e);background:var(--abr-bg-page,#f2f2f5)}.error-PQqoYV{color:var(--abr-error,#f04131);background:rgba(240,65,49,.08);border-color:rgba(240,65,49,.2)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"glyph": `glyph-bCgWZh`,
	"muted": `muted-xe1h4q`,
	"error": `error-PQqoYV`
};
export default ___CSS_LOADER_EXPORT___;
